import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Modal from '../../containers/common/Modal';
import { FadeInTransition } from '../transitions/transitions';
import DoctorShowingPrescription from '../../gif/DoctorShowingPrescription.gif';
import CloseCircleIcon from '../../images/common/close-circle.svg';

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
`;

const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  margin: 0 24px;
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  position: relative;
`;

const TimerBadge = styled.div`
  border-radius: 20px;
  padding: 2px 6px;
  font-size: 10px;
  font-weight: 400;
  color: #686670;
  margin-bottom: 16px;
`;

const GifContainer = styled.img`
  width: 80px;
  height: 80px;
  margin-bottom: 16px;
  scale: 1.05;
`;

const CTAButton = styled.button`
  margin-top: 20px;
  background: var(--primary, #714fff);
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 14px 24px;
  font-size: 14px;
  font-weight: 600;
  width: 100%;
  cursor: pointer;
`;

const DisclaimerPopup = ({
  show,
  onClose,
  disclaimerText,
  mode = 'timer', // 'timer' for home tab, 'cta' for reimbursement
  timerSeconds = 5,
  ctaText = 'I Understand',
}) => {
  const [countdown, setCountdown] = useState(timerSeconds);
  const [visible, setVisible] = useState(false);
  const [optText, coPaymentText] = disclaimerText || [];

  useEffect(() => {
    if (show) {
      setVisible(true);
      setCountdown(timerSeconds);
    }
  }, [show, timerSeconds]);

  useEffect(() => {
    if (!show || mode !== 'timer' || countdown <= 0) return;
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [show, mode, countdown]);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => onClose(), 200);
  };

  if (!show) return null;

  return (
    <Modal>
      <FadeInTransition in={visible} timeout={200} appear>
        <Overlay
          onClick={mode === 'timer' && countdown <= 0 ? handleClose : undefined}
        >
          <Card onClick={(e) => e.stopPropagation()}>
            {mode === 'timer' && (
              <div className="flex flex-row-reverse w-full ">
                {countdown > 0 ? (
                  <TimerBadge className="border border-primary">
                    You can close after{' '}
                    <span className="text-xxs text-primary font-medium">
                      {countdown} sec
                    </span>
                  </TimerBadge>
                ) : (
                  <img
                    src={CloseCircleIcon}
                    alt="close"
                    width={20}
                    height={20}
                    onClick={handleClose}
                    style={{ cursor: 'pointer' }}
                  />
                )}
              </div>
            )}
            <div className="w-20 h-20 mb-4">
              <GifContainer src={DoctorShowingPrescription} alt="attention" />
            </div>
            <div className="text-gray-600" style={{ letterSpacing: '0.24px' }}>
              <div
                className="font-semibold text-xs"
                style={{ lineHeight: '19.2px' }}
              >
                {optText}
              </div>
              <div
                className="font-medium mt-2"
                style={{ fontSize: '11px', lineHeight: '17.6px' }}
              >
                {coPaymentText}
              </div>
            </div>
            {mode === 'cta' && (
              <CTAButton onClick={handleClose}>{ctaText}</CTAButton>
            )}
          </Card>
        </Overlay>
      </FadeInTransition>
    </Modal>
  );
};

export default DisclaimerPopup;
